import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

// Copiado de petrol-ng (C:\git\gitlab\petrol-ng\src\components\button\button.ts).
// Ver plan/plan-3-boton_petrol_ng.md. No modificar la lógica sin actualizar
// también el original en petrol-ng si corresponde (ver "Changelog y modelo
// de copy-paste" en el README de petrol-ng).
//
// EXTENSIÓN LOCAL (ver plan/plan-8-boton_success_y_warning_solido.md): esta
// copia se aparta del original en dos puntos, para los botones de descarga
// Excel/PDF:
//   - Se agregó la variante 'success' (no existe en petrol-ng).
//   - 'warning' pasó de outline (como en petrol-ng) a sólido.
// Si se vuelve a copiar `button.ts` desde petrol-ng en el futuro, hay que
// reaplicar estos dos cambios a mano.

export type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'warning'
  | 'tertiary'
  | 'success';
export type ButtonType = 'button' | 'submit' | 'reset';

const ROOT_BASE =
  'group relative inline-flex items-center justify-center gap-2 rounded-none px-4 py-2.5 text-[13px] font-bold uppercase tracking-wider outline-none transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50 ' +
  'focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary dark:focus-visible:ring-primary-light dark:focus-visible:ring-offset-slate-900';

const ROOT_VARIANT: Record<ButtonVariant, string> = {
  primary:
    'bg-primary text-primary-contrast hover:bg-primary-hover dark:bg-primary-light dark:text-slate-900 dark:hover:bg-primary',
  secondary:
    'border border-primary bg-white text-primary hover:bg-primary hover:text-primary-contrast ' +
    'dark:border-primary-light dark:bg-transparent dark:text-primary-light dark:hover:bg-primary-light dark:hover:text-slate-900',
  danger:
    'border border-danger bg-white text-danger hover:bg-danger hover:text-white ' +
    'dark:border-danger-dark dark:bg-transparent dark:text-danger-dark dark:hover:bg-danger-dark dark:hover:text-slate-900',
  warning:
    'bg-warning text-white hover:brightness-90 dark:bg-warning-dark dark:text-slate-900 dark:hover:brightness-90',
  tertiary:
    'text-primary hover:text-primary-hover dark:text-primary-light dark:hover:text-white',
  success:
    'bg-success text-white hover:brightness-90 dark:bg-success-dark dark:text-slate-900 dark:hover:brightness-90',
};

/**
 * Botón con hover de color clásico (transition-colors, 200ms). Cinco variantes:
 * primario y warning/danger llenos o outline según corresponda, secundario
 * (outline), y terciario (solo texto, sin borde ni fondo) para acciones
 * secundarias tipo "Cancelar" o "Limpiar filtros".
 */
@Component({
  selector: 'petrol-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './button.component.html',
})
export class PetrolButtonComponent {
  readonly variant = input<ButtonVariant>('primary');
  readonly type = input<ButtonType>('button');
  readonly disabled = input(false);
  readonly fullWidth = input(false);

  protected readonly rootClasses = computed(() => {
    const width = this.fullWidth() ? 'w-full' : '';
    return `${ROOT_BASE} ${width} ${ROOT_VARIANT[this.variant()]}`;
  });
}
